import ProductTile from "@/components/product_tile";
import { useState } from "react";
import ApplicationPhotoTile from "@/components/inspiration/application_photos/application_photo_tile";
import { shareIcon } from "@/lib/icons";
import GalleryService from "@/lib/services/galleries";
import { loadConfig } from "@/lib/utils.js";
import PageLayout from "@/components/PageLayout";
import SimpleModal from "@/components/simple_modal";
import Clipboard from "@/components/clipboard";
import Lightbox from "@/components/lightbox";
import { is_mobile } from "@/lib/utils.js";

export default function ApplicationGalleryPage (props) {
  const {
    app_gallery,
    cart_enabled,
    stylesheet, 
    favicon,
    page_layout,
    referer,
    mobile
  } = props;

  if (typeof window !== "undefined") {
    var pageUrl = window.location.href;
  }

  const [showShare, setShowShare] = useState(false);
  const [contentsMode, setContentsMode] = useState('photos');
  const [lightBoxIndex, setLightBoxIndex] = useState(null);

  const showLightBox = (e, index) => {
    e.stopPropagation();
    setLightBoxIndex(index);
  }
  
  const hideLightBox = () => {
    setLightBoxIndex(null);
    document.body.style.overflow = "visible";
  }

  const getProducts = () => {
    let products = []
    let product_ids = new Set()
    app_gallery.photos.forEach((photo) => {
      photo.product_hot_spots.forEach((hot_spot) => {
        if(!product_ids.has(hot_spot.product.id))
          products.push(hot_spot.product);
        product_ids.add(hot_spot.product.id);
      });
    });
    return products;
  }

  const getSpaces = () => {
    let spaces = []
    let space_ids = new Set()
    app_gallery.photos.forEach((photo) => {
      photo.spaces.forEach((space) => {
        if(!space_ids.has(space.id))
          spaces.push(space);
        space_ids.add(space.id);
      });
    });
    return spaces;
  }

  const getApplicationTypes = () => {
    let application_types = []
    let application_type_ids = new Set()
    app_gallery.photos.forEach((photo) => {
      photo.application_types.forEach((application_type) => {
        if(!application_type_ids.has(application_type.id))
          application_types.push(application_type);
        application_type_ids.add(application_type.id);
      });
    });
    return application_types;
  }

  let city_state = [];
  if(app_gallery.city)
    city_state.push(app_gallery.city)
  if(app_gallery.state)
    city_state.push(app_gallery.state)

  return (
    <PageLayout
      page_layout={page_layout}
      stylesheet={stylesheet}
      favicon={favicon}
      cart_enabled={cart_enabled}
      title={app_gallery.name}
      breadcrumbs={ (<a href={referer}>&lt; Back</a>) }
    >
      {showShare &&
        <SimpleModal show={showShare} setShow={setShowShare}>
          <div className="share-content">
            <h4 className="share-heading">Share This Page</h4>
            <Clipboard pageUrl={pageUrl} />
          </div>
        </SimpleModal>
      }
      <div className='lexcms-application-gallery-page'>
        <div className='gallery-left-container'>
          <div className='details-container'>
            <h2 className='gallery-name'>{app_gallery.name}</h2>
            <div className='details-block'>
              <p className='gallery-details-content gallery-city-state'>{city_state.join(', ')}</p>
            </div>
            <div className='details-block'>
              <h4 className='gallery-details-heading'>Story</h4>
              <div className='gallery-details-content' dangerouslySetInnerHTML={{__html: app_gallery.story}}></div>
            </div>
            { app_gallery.contributors.length > 0 && 
              <div className='details-block'>
                <h4 className='gallery-details-heading'>Project Contributors</h4>
                <div className='gallery-details-content'>
                  {app_gallery.contributors.map((contributor, i) => {
                    return <p className='gallery-details-content-item' key={i}>{contributor.role}: {contributor.name}</p>;
                  })}             
                </div>
              </div>
            }
            <div className='details-block'>
              <h4 className='gallery-details-heading'>Applications</h4>
              <div className='gallery-details-content'>
                {getApplicationTypes().map((application_type, i) => {
                  return <p className='gallery-details-content-item' key={i}>{application_type.name}</p>;
                })}
              </div>
            </div>
            {getSpaces().length > 0 &&
              <div className='details-block'>
              <h4 className='gallery-details-heading'>Spaces</h4>
              <div className='gallery-spaces-content'>
              {getSpaces().map((space, i) => {
                return <div className='space-pill' key={i}>{space.name}</div>;
              })}
              </div>
            </div>
            }
          </div>
        </div>
        <div className='gallery-right-container'>
          <div className='app-gallery-meta-container'>
            <div className='app-gallery-contents-toggle-container'>
              <p className='app-gallery-filter-text'>Showing {contentsMode == 'photos'? app_gallery.photos.length:getProducts().length}:</p>
              <select
                className='lexcms-search-input lexcms-line-card-filter-toggle-button app-gallery-contents-toggle' 
                value={contentsMode}
                onChange={(e) => setContentsMode(e.target.value)}
              >
                <option value="photos">Photos</option>
                { getProducts().length > 0 && 
                  <option value="products">Products</option>
                }
              </select>
            </div>
            <div className='action-buttons-container'>
              <a className='lexcms-action-link' onClick={() => {setShowShare(true)}}>
                { shareIcon } Share this Gallery
              </a>
            </div>
          </div>
          <div className='lexcms-result-container app-gallery-contents-container'>
            { contentsMode == 'photos' && 
              <div className='app-photo-list content-photos'>
                { app_gallery.photos?.map((photo, i) => {
                  return <ApplicationPhotoTile app_photo={photo} key={photo.id} index={i} showLightBox={showLightBox} mobile={mobile} />;
                })
                }
              </div>
            }
            { contentsMode == 'products' && 
              <div className='lexcms-product-list content-products'>
                { getProducts().map((product, i) => {
                  return (<div className="lexcms-product-tile-container" key={i}>
                      <ProductTile
                        product={product} 
                        key={i} />
                    </div>
                    )
                }) }
              </div>
            }
          </div>
        </div>
        <Lightbox index={lightBoxIndex} images={app_gallery.photos} hideLightBox={hideLightBox} />
      </div>
    </PageLayout>
  )
}

export async function getServerSideProps({ params, req }) {
  let id = params['show']
  let token = req?.headers['lex-api-token'];

  let service = await GalleryService.build(token, req?.headers?.host);
  let resp, config;
  let referer = req?.headers?.referer?.split("/").slice(3).join("/");
  let mobile = is_mobile(req?.headers['user-agent'])
  if(referer)
    referer = "/" + referer;
  else
    referer = "/lex-cms/inspiration/galleries/index"
  try {
    resp = await service.show(id);
    config = service.config;
  } catch (e) {
    console.log(e)
    return {
      notFound: true,
    };
  }
  let pageLayout = loadConfig(service);

  return {
    props: { id: id, app_gallery: resp, referer: referer, ...pageLayout, mobile: mobile },
  };
}
